module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/remote/card/question/card-question.component.scss
// module id = ./src/app/remote/card/question/card-question.component.scss
// module chunks = main